import ui from "./ui";
import forms from "./forms";
import pages from "./pages";
import fields from "./fields";
import layout from "./layout";
import collaborators from "./collaborators";
import logic from "./logic";
import auth from "./auth";
import selected from "./selected";
import markers from "./markers";
import payment from "./payment";
import configs from "./configs";
import options from "./selectableOptions";
import validations from "./validations";
import settings from "./settings";
import chat from "./chat";
import integrations from "./integrations/reducers";

const reducer = {
    ui,
    forms,
    pages,
    fields,
    layout,
    collaborators,
    logic,
    auth,
    selected,
    markers,
    payment,
    configs,
    validations,
    options,
    settings,
    chat,
    integrations,
};

export default reducer;
